import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';
import { normalizeListResponse, buildPaginationMeta } from './normalizers';

const BASE_URL = COMMUNITY_ENDPOINTS.CHALLENGES;

export const getAll = (params = {}) =>
  communityHttpClient.get(BASE_URL, { params });

export const getBySlug = (slug) =>
  communityHttpClient.get(`${BASE_URL}/${slug}/`);

export const create = (data) =>
  communityHttpClient.post(`${BASE_URL}/`, data);

export const update = (slug, data) =>
  communityHttpClient.put(`${BASE_URL}/${slug}/`, data);

export const remove = (slug) =>
  communityHttpClient.delete(`${BASE_URL}/${slug}/`);

export const submitFlag = (slug, flag) =>
  communityHttpClient.post(`${BASE_URL}/${slug}/submit_flag/`, { flag });

export const getLeaderboard = () =>
  communityHttpClient.get(`${BASE_URL}/leaderboard/`);

export const getNormalizedList = async (params = {}) => {
  const response = await getAll(params);
  const normalized = normalizeListResponse(response.data);
  const meta = buildPaginationMeta({
    response: normalized,
    page: typeof params.page === 'number' ? params.page : Number(params.page) || 1,
    pageSize: typeof params.page_size === 'number'
      ? params.page_size
      : Number(params.page_size || params.pageSize || 0)
  });

  return {
    data: normalized.results,
    meta
  };
};

export default {
  getAll,
  getBySlug,
  create,
  update,
  delete: remove,
  remove,
  submitFlag,
  getLeaderboard,
  getNormalizedList
};
